// Utilities
import { builderFetch } from '@automator/builder/utils';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * Updates the trigger logic.
 *
 * @param {String} triggerLogic The item ID
 * @throws Will throw an error if the item ID is not defined
 * @return {Promise} The apiFetch promise
 */
const setTriggerLogic = ( triggerLogic ) => {
	// Event name
	const eventName = 'uap/builder/core/item/set-trigger-logic';

	// If the item is not define, stop here
	if ( isEmpty( triggerLogic ) ) {
		throw new Error( `setTriggerLogic: The trigger logic can't be empty` );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'triggers_change_logic',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			trigger_logic: triggerLogic
		},
		snackbar: {
			loading: escapeHTML( __( 'Updating trigger logic', 'uncanny-automator' ) ),
			success: escapeHTML( __( 'Trigger logic updated successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					triggerLogic: triggerLogic
				}
			} ) );
		}

		return response;
	} );
}

export default setTriggerLogic;
